<script setup>
import {onMounted} from 'vue'
import FormControlTypeText from "@/common/form-control-type/FormControlTypeText.vue"
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
})

const appStore = useAppStore()

onMounted(() => {
    props.field.required = !appStore.pageEditorMode
})
</script>

<template>
    <FormControlTypeText v-bind="$props" ref="baseControl"/>
</template>